import { createSelector } from 'reselect';
import ViewTransactionsPageColumns from '../../containers/ViewTransactionsPageColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.TRANSACTION_MANAGEMENT.isLoading;
export const getCheckedRows = (state) => state.listing.TRANSACTION_MANAGEMENT.selectedRows;
export const getData = TableDefinitions.TRANSACTION_MANAGEMENT.getDataFunction();
export const getColumns = createSelector(getData, ViewTransactionsPageColumns);
